import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon([
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.3025 7.9545c-1.7429.2463-2.0286-1.6212-2.0286-2.0286V1.5h-7.561C5.4909 1.5 4.5 2.4908 4.5 3.713v16.2284c0 1.2222.9908 2.213 2.213 2.213h11.8025c1.2222 0 2.2129-.9908 2.2129-2.213V7.9544z",
        clipRule: "evenodd"
    }, "0"),
    /*#__PURE__*/ _jsx("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M16.5 1.5V6H21z",
        clipRule: "evenodd"
    }, "1")
], "StatusDraft", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
